import React from "react";
import {useSelector} from "react-redux";
import RootState from "../../../../Types/states/RootState";
import {CurrentModalNameEnum} from "../../../../Enums/CurrentModalNameEnum";
import UseModal from "../../../../Services/CustomHooks/useModal";
import MobileReviewReceivedProposalModal from "./MobileReviewReceivedProposalModal/MobileReviewReceivedProposalModal";
import styles from "../../Modals.module.scss";
import {Modal} from "@devapo/devapo-ui";

const MobileReviewReceivedProposal = () => {

    const {currentOpenModal}  = useSelector((state : RootState) => state.modalPopup)
    const {closeAll} = UseModal()

    return (
        <>
            <Modal
                isOpen={currentOpenModal === CurrentModalNameEnum.MOBILE_REVIEW_RECEIVED_PROPOSAL}
                onClose={() => closeAll()}
                modalClass={styles.modal}
                backdropClass={styles.backdrop}
            >
                <MobileReviewReceivedProposalModal />
            </Modal>
        </>
    )
}
export default MobileReviewReceivedProposal;